import { legalDocumentSources } from './source.js';
import { festivalAddendumV1_0 } from './festival-addendum-v1.0.js';
import { termsV1_0 } from './source-v1.0.js';
const DOCUMENT_METADATA = {
    terms: {
        id: 'terms_of_service',
        type: 'terms',
        title: 'Filmspo Terms of Service',
        version: '1.1',
        summary: 'The rules for using Filmspo websites, mobile applications, APIs, and related services.',
        approvalStatus: 'owner_approved_for_implementation',
        ownerApprovedAt: '2026-09-22',
        externalAttorneyReviewStatus: 'not_requested',
        externalAttorneyReviewedAt: null,
        isActive: false,
        isSuperseded: false,
        sourceBaseline: {
            version: '0.1',
            sha256: '21151ecbb6da69061a39004fced1e3edaab677886592f0067ef0cf8f4b532d3f',
        },
        supersedesPublicVersion: {
            version: '1.0',
            sha256: '837930b3cf19ef9b042e500b7fef04a419bec92be0025e43a362b9b9664d421a',
        },
        publicContentSha256: 'bf4af8ce23b639e6510e3d5e56c373c0936ecbe7c43dd56d2a6665968d7800fb',
        publicUrl: '/terms',
        effectiveDate: {
            status: 'pending_first_publication',
            effectiveAt: null,
            display: 'Effective upon publication',
        },
        materialChange: {
            isMaterialChange: false,
            summary: 'Version 1.1 corrects refund allocation wording and removes superseded Stripe implementation detail without changing the approved economics.',
            reacceptanceReview: 'required_for_future_acceptance_implementation',
        },
    },
    festival_addendum: {
        id: 'festival_connected_account_addendum',
        type: 'festival_addendum',
        title: 'Filmspo Festival/Connected-Account Addendum',
        version: '1.1',
        summary: 'The separately versioned terms for Festival Entities and connected-account features.',
        approvalStatus: 'owner_approved_for_implementation',
        ownerApprovedAt: '2026-09-22',
        externalAttorneyReviewStatus: 'not_requested',
        externalAttorneyReviewedAt: null,
        isActive: false,
        isSuperseded: false,
        sourceBaseline: {
            version: '0.1',
            sha256: 'f3361c133ab64b25160ce8b39d33b29f07fe81524a0f75d66200a62ac3feac18',
        },
        supersedesPublicVersion: {
            version: '1.0',
            sha256: '84543ecc6e64743f423b9f3c3a8b671caa382a6aba1a4ce8feb0e3516e0fbf64',
        },
        publicContentSha256: '4e7d2b8babcf05a7432ecd1497fcc4961e599d6ef116b2f3b3a061a058260862',
        publicUrl: '/terms?version=1.1#festival-connected-account-addendum',
        effectiveDate: {
            status: 'pending_first_publication',
            effectiveAt: null,
            display: 'Effective upon publication',
        },
        materialChange: {
            isMaterialChange: false,
            summary: 'Version 1.1 states the approved refund economics without prescribing Stripe implementation details.',
            reacceptanceReview: 'required_for_future_acceptance_implementation',
        },
    },
    privacy: {
        id: 'privacy_policy',
        type: 'privacy',
        title: 'Filmspo Privacy Policy',
        version: '1.0',
        summary: 'How Filmspo collects, uses, shares, retains, and protects information.',
        approvalStatus: 'owner_approved_for_implementation',
        ownerApprovedAt: '2026-09-21',
        externalAttorneyReviewStatus: 'not_requested',
        externalAttorneyReviewedAt: null,
        isActive: false,
        isSuperseded: false,
        sourceBaseline: {
            version: '0.1',
            sha256: '844cad429a7c6d86d8a7d9ae5f4606e4cda68ca128046e187a9692edb874a1a9',
        },
        publicContentSha256: 'b29b19044d40a118667756e6c56070c1bc864a135deb1f2446530d9c10e3526e',
        publicUrl: '/privacy',
        effectiveDate: {
            status: 'pending_first_publication',
            effectiveAt: null,
            display: 'Effective upon publication',
        },
        materialChange: {
            isMaterialChange: true,
            summary: 'Initial public version 1.0 packaged from the approved 0.1 source baseline.',
            reacceptanceReview: 'required_for_future_acceptance_implementation',
        },
    },
};
export const SERIALIZATION_VERSION = 'filmspo-legal-content-v1';
function inlineToSerialization(inline) {
    if (inline.kind === 'text')
        return `text:${JSON.stringify(inline.value)}`;
    if (inline.kind === 'link')
        return `link:${JSON.stringify(inline.label)}:${JSON.stringify(inline.href)}`;
    return `strong:${inline.children.map(inlineToSerialization).join('')}`;
}
function blockToSerialization(block) {
    switch (block.kind) {
        case 'heading':
            return ['heading', String(block.level), block.anchor, block.text]
                .map(value => JSON.stringify(value))
                .join('|');
        case 'paragraph':
            return ['paragraph', block.inlines.map(inlineToSerialization).join('')]
                .map(value => JSON.stringify(value))
                .join('|');
        case 'list':
            return [
                'list',
                block.ordered ? 'ordered' : 'unordered',
                block.items.map(item => item.map(inlineToSerialization).join('')).join('\u001e'),
            ]
                .map(value => JSON.stringify(value))
                .join('|');
        case 'table':
            return [
                'table',
                block.headers.map(cell => cell.map(inlineToSerialization).join('')).join('\u001f'),
                block.rows
                    .map(row => row.map(cell => cell.map(inlineToSerialization).join('')).join('\u001f'))
                    .join('\u001e'),
            ]
                .map(value => JSON.stringify(value))
                .join('|');
    }
}
export function serializeLegalDocumentContent(document) {
    return [
        SERIALIZATION_VERSION,
        `id=${JSON.stringify(document.id)}`,
        `version=${JSON.stringify(document.version)}`,
        `title=${JSON.stringify(document.title)}`,
        `summary=${JSON.stringify(document.summary)}`,
        ...document.blocks.map(blockToSerialization),
        '',
    ].join('\n');
}
const parsedDocuments = Object.keys(legalDocumentSources).map(type => {
    const metadata = DOCUMENT_METADATA[type];
    const blocks = parseLegalMarkdown(legalDocumentSources[type]);
    return { ...metadata, blocks };
});
export const legalDocuments = parsedDocuments;
export const legalDocumentByType = Object.fromEntries(legalDocuments.map(document => [document.type, document]));
/** Immutable LEGAL-004 terms snapshot for the LEGAL-005 v1.0 evidence migration. */
export const legalDocumentByTypeV1_0 = {
    terms: {
        ...legalDocumentByType.terms,
        supersedesPublicVersion: undefined,
        version: '1.0',
        summary: 'The rules for using Filmspo websites, mobile applications, APIs, and related services.',
        ownerApprovedAt: '2026-09-21',
        publicContentSha256: '837930b3cf19ef9b042e500b7fef04a419bec92be0025e43a362b9b9664d421a',
        materialChange: {
            isMaterialChange: true,
            summary: 'Initial public version 1.0 packaged from the approved 0.1 source baseline.',
            reacceptanceReview: 'required_for_future_acceptance_implementation',
        },
        blocks: parseLegalMarkdown(termsV1_0),
    },
    festival_addendum: {
        ...legalDocumentByType.festival_addendum,
        supersedesPublicVersion: undefined,
        version: '1.0',
        ownerApprovedAt: '2026-09-21',
        publicContentSha256: '84543ecc6e64743f423b9f3c3a8b671caa382a6aba1a4ce8feb0e3516e0fbf64',
        publicUrl: '/terms?version=1.0#festival-connected-account-addendum',
        materialChange: {
            isMaterialChange: true,
            summary: 'Initial public version 1.0 packaged from the approved 0.1 source baseline.',
            reacceptanceReview: 'required_for_future_acceptance_implementation',
        },
        blocks: parseLegalMarkdown(festivalAddendumV1_0),
    },
};
/** Immutable payment disclosure snapshot for the LEGAL-005 v1.0 evidence migration. */
export const paymentDisclosureV1_0 = {
    id: 'submission_payment_disclosure',
    type: 'payment_disclosure',
    title: 'Paid submission fee and refund disclosure',
    version: '1.0',
    content: 'The Filmspo Service Fee is nonrefundable except where applicable law requires otherwise. An Entry Fee refund normally does not refund the Filmspo Service Fee.',
    contentSha256: 'ee71c203033f558e1adf7c2f5fda44125c86c06e81d47385d7accea17f8339e9',
    sourceDocumentId: 'terms_of_service',
    sourceVersion: '1.0',
    approvalStatus: 'owner_approved_for_implementation',
    publicUrl: '/terms?version=1.0#12-paid-submissions-stripe-and-fees',
};
/** Payment disclosure wording excerpted from Terms of Service v1.1. */
export const paymentDisclosure = {
    id: 'submission_payment_disclosure',
    type: 'payment_disclosure',
    title: 'Paid submission fee and refund disclosure',
    version: '1.1',
    content: 'A normal refund returns the authorized Entry Fee amount. The Filmspo Service Fee remains charged except where applicable law requires an authorized exception.',
    contentSha256: 'b4e060a5177c9802d7577b0076a33056d9d9e7d0fd10ed3f78ac2a6435851ced',
    sourceDocumentId: 'terms_of_service',
    sourceVersion: '1.1',
    supersedesPublicVersion: {
        version: '1.0',
        sha256: 'ee71c203033f558e1adf7c2f5fda44125c86c06e81d47385d7accea17f8339e9',
    },
    approvalStatus: 'owner_approved_for_implementation',
    publicUrl: '/terms?version=1.1#12-paid-submissions-stripe-and-fees',
};
export function getLegalDocument(type) {
    return legalDocumentByType[type];
}
export function getLegalDocumentVersion(type, version) {
    if (version === undefined || version === legalDocumentByType[type].version)
        return legalDocumentByType[type];
    if (version === '1.0')
        return type === 'privacy' ? legalDocumentByType.privacy : legalDocumentByTypeV1_0[type];
    return undefined;
}
function parseInline(value) {
    const inlines = [];
    const pattern = /\*\*([^*]+)\*\*|\[([^\]]+)\]\(([^)]+)\)|([\w.+-]+@[\w.-]+\.[A-Za-z]{2,})/g;
    let cursor = 0;
    let match;
    while ((match = pattern.exec(value))) {
        if (match.index > cursor)
            inlines.push({ kind: 'text', value: value.slice(cursor, match.index) });
        if (match[1])
            inlines.push({ kind: 'strong', children: parseInline(match[1]) });
        else if (match[2] && match[3])
            inlines.push({ kind: 'link', label: match[2], href: match[3] });
        else if (match[4])
            inlines.push({ kind: 'link', label: match[4], href: `mailto:${match[4]}` });
        cursor = pattern.lastIndex;
    }
    if (cursor < value.length)
        inlines.push({ kind: 'text', value: value.slice(cursor) });
    return inlines.length ? inlines : [{ kind: 'text', value }];
}
function normalizeTableCell(value) {
    return value.trim().replace(/\\\|/g, '|');
}
function isTableSeparator(line) {
    return /^\|?\s*:?-+:?\s*(\|\s*:?-+:?\s*)+\|?$/.test(line);
}
function splitTableRow(line) {
    const trimmed = line.trim().replace(/^\|/, '').replace(/\|$/, '');
    return trimmed.split(/(?<!\\)\|/).map(normalizeTableCell);
}
function slugify(value) {
    return value
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
}
function parseLegalMarkdown(source) {
    const lines = source.replace(/\r\n?/g, '\n').split('\n');
    const blocks = [];
    let index = 0;
    const anchors = new Map();
    const uniqueAnchor = (text) => {
        const base = slugify(text) || 'section';
        const count = anchors.get(base) ?? 0;
        anchors.set(base, count + 1);
        return count === 0 ? base : `${base}-${count + 1}`;
    };
    while (index < lines.length) {
        const line = lines[index].trim();
        if (!line) {
            index += 1;
            continue;
        }
        const heading = /^(#{2,3})\s+(.+)$/.exec(line);
        if (heading) {
            blocks.push({
                kind: 'heading',
                level: heading[1].length,
                text: heading[2].trim(),
                anchor: uniqueAnchor(heading[2].trim()),
            });
            index += 1;
            continue;
        }
        if (line.startsWith('|') &&
            index + 1 < lines.length &&
            isTableSeparator(lines[index + 1].trim())) {
            const header = splitTableRow(line).map(parseInline);
            index += 2;
            const rows = [];
            while (index < lines.length && lines[index].trim().startsWith('|')) {
                rows.push(splitTableRow(lines[index]).map(parseInline));
                index += 1;
            }
            blocks.push({ kind: 'table', headers: header, rows });
            continue;
        }
        const listItem = /^(?:(\d+)\.|-)\s+(.+)$/.exec(line);
        if (listItem) {
            const ordered = Boolean(listItem[1]);
            const items = [];
            while (index < lines.length) {
                const item = /^(?:(\d+)\.|-)\s+(.+)$/.exec(lines[index].trim());
                if (!item || Boolean(item[1]) !== ordered)
                    break;
                items.push(parseInline(item[2].trim()));
                index += 1;
            }
            blocks.push({ kind: 'list', ordered, items });
            continue;
        }
        const paragraphLines = [line];
        index += 1;
        while (index < lines.length) {
            const next = lines[index].trim();
            if (!next || /^(#{2,3})\s+/.test(next) || /^(?:(\d+)\.|-)\s+/.test(next))
                break;
            if (next.startsWith('|') &&
                index + 1 < lines.length &&
                isTableSeparator(lines[index + 1].trim()))
                break;
            paragraphLines.push(next);
            index += 1;
        }
        blocks.push({ kind: 'paragraph', inlines: parseInline(paragraphLines.join(' ')) });
    }
    return blocks;
}
//# sourceMappingURL=index.js.map